<template>

    <div id="app">

        <breakpoint-debugger v-if="bpDebugger"></breakpoint-debugger>

        <router-view></router-view>

    </div>

</template>

<script>

    import BreakpointDebugger from './components/BreakpointDebugger';

    export default {

        name: 'App',

        components: {
            BreakpointDebugger
        },

        data() {
            return {
                bpDebugger: false
            }
        }

    }

</script>

<style lang="scss">

    @import url('https://fonts.googleapis.com/css?family=Roboto:300,300i');

    *,
    *:before,
    *:after {
        box-sizing: border-box;
    }

    body,
    html {
        overflow: hidden;
        margin: 0;
        padding: 0;
        width:100%;
        height: 100%;
    }

    body {
        background-image: url('/images/bg@1x.png');
        background-size: 1286px 2436px;
        background-position: 50% 0;
        position: relative;

        /* @2x */
        @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
            background-image: url('/images/bg@2x.png');
        }
        /* @3x */
        @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 350dpi) {
            background-image: url('/images/bg@3x.png');
        }

        &::after {
            content: '';
            background-image: url('/images/intro@1x.png');
            background-position: 50% 50%;
            background-size: contain;
            background-repeat: no-repeat;
            width: 100vw;
            height: 80vh;
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: -3;
            transform: translate(-50%, -50%);

            /* @2x */
            @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
                background-image: url('/images/intro@2x.png');
            }
            /* @3x */
            @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 350dpi) {
                background-image: url('/images/intro@3x.png');
            }
        }
    }

    #app {
        font-family: 'Roboto', sans-serif;
        font-weight: 300;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .vid {
        /*position: absolute;*/
        /*top: 0;*/
        width: 100px;
        height: 50px;
    }

</style>
